import * as types from '../mutation-types'
import journalService from '../../services/journals'

const state = {
    loading: false,
    errors: null,
    expenses: [],
    exp_ledgeraccs:[]
}

const actions = {
    getAll({ commit }, data) {
        commit(types.EXPENSE_LOADING, true)
        journalService.getAll(data).then(
            response => {

                commit(types.LOAD_EXPENSES, response.data)
                commit(types.EXPENSE_LOADING, false)
            },
            error => {
                commit(types.EXPENSE_FAILURE, error)
                commit(types.EXPENSE_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.EXPENSE_LOADING, true)
        commit(types.EXPENSE_FAILURE, null)
        journalService.add(data).then(
            response => {
                data.id = response.data.id
                data.recorded_by = response.data.recorded_by
                data.ledgeracc = response.data.ledgeracc
                commit(types.ADD_EXPENSE, data)
                commit(types.EXPENSE_LOADING, false)
            },
            error => {
                commit(types.EXPENSE_FAILURE, error)
                commit(types.EXPENSE_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.EXPENSE_LOADING, true)
        commit(types.EXPENSE_FAILURE, null)
        journalService.update(data.journal)
            .then(
                response => {

                    data.journal.ledgeracc = response.data.ledgeracc

                    //console.log(data)
                    commit(types.UPDATE_EXPENSE, data)
                    commit(types.EXPENSE_LOADING, false)
                },
                error => {
                    commit(types.EXPENSE_FAILURE, error)
                    commit(types.EXPENSE_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.EXPENSE_LOADING, true)
        commit(types.EXPENSE_FAILURE, null)
        journalService.delete(data.journal.id)
            .then(
                response => {

                    commit(types.DELETE_EXPENSE, data)
                    commit(types.EXPENSE_LOADING, false)
                },
                error => {
                    commit(types.EXPENSE_FAILURE, error)
                    commit(types.EXPENSE_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_EXPENSE](state, payload) {
        state.expenses.unshift(payload);
    },
    [types.LOAD_EXPENSES](state, payload) {
        state.expenses = payload.expenses
        state.exp_ledgeraccs = payload.ledgeraccs
    },
    [types.UPDATE_EXPENSE](state, payload) {
        Object.assign(state.expenses[payload.index], payload.journal);
    },
    [types.DELETE_EXPENSE](state, payload) {
        state.expenses.splice(payload.index, 1)
    },
    [types.EXPENSE_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.EXPENSE_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    EXPENSES: state => {
        return state.expenses
    },

    EXPENSE_LEDGERACCS: state => {
      return state.exp_ledgeraccs
  },

    EXPENSE_ERROR: state => {
        return state.errors
    },

    EXPENSE_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/expenses.js